import { c as _c } from "react/compiler-runtime";
import LINKS from '../../../../../configs/links';
import { ClickableArea } from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import Badge from '../../../../common/base/Badge';
import { Div } from '../../../../common/helpers/StyledUtils';
import { IconName } from '../../../../common/base/Icon';
import { OutpostGetStartedStepProps } from '../GetStartedView';
const WhatsNextCard: React.FC<{
  heading: string;
  text: string;
  icon: IconName;
  to?: string;
  href?: string;
}> = t0 => {
  const $ = _c(18);
  const {
    heading,
    text,
    icon,
    to,
    href
  } = t0;
  const t1 = href ? Link : undefined;
  const t2 = href ? "_blank" : undefined;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      px: 32
    };
    t4 = {
      px: 32
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      b: 4
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== icon) {
    t6 = <Badge subtle={true} h={t3} w={t4} icon={icon} m={t5} />;
    $[3] = icon;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      b: 1
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== heading) {
    t8 = <Text bold={true} m={t7}>{heading}</Text>;
    $[6] = heading;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== text) {
    t9 = <Text muted={true}>{text}</Text>;
    $[8] = text;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== href || $[11] !== t1 || $[12] !== t2 || $[13] !== t6 || $[14] !== t8 || $[15] !== t9 || $[16] !== to) {
    t10 = <StyledCard raised="button" overflow_hidden={true}><StyledCardSection><ClickableArea as={t1} to={to} href={href} target={t2} no_underline={true} p={4}>{t6}{t8}{t9}</ClickableArea></StyledCardSection></StyledCard>;
    $[10] = href;
    $[11] = t1;
    $[12] = t2;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
    $[16] = to;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
const WhatsNext: React.FC<OutpostGetStartedStepProps> = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Div grid={{
      columns: 2,
      gap: 4
    }}><WhatsNextCard heading="Invite your team" text="Add team members to collaborate on your project." icon="group" to="/settings/organization/members" /><WhatsNextCard heading="Configure the user portal" text="Set up the hosted portal for your tenants." icon="portal" to="/settings/project/user-portal" /><WhatsNextCard heading="Migrate your existing webhooks" text="Ensure compatibility and import with your webhooks." icon="swap" href={LINKS.outpost.migrate} /><WhatsNextCard heading="Check the docs" text="Explore guides, API references, and examples." icon="docs" href={LINKS.outpost.docs} /></Div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default WhatsNext;